import React from 'react';

/**
 * SubmitInputField - regular input field that blurs when pressing enter.
 * @param {*} props
 * @returns <input>
 */
const SubmitInputField = React.forwardRef((props, ref) => {
  const {
    handleSubmit,
    ...rest
  } = props;
  const handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
      if (handleSubmit) handleSubmit();
    }
  };

  return (
    <input
      ref={ref}
      {...rest}
      onKeyUp={handleKeyUp}
    />
  );
});

export default SubmitInputField;
